export default __webpack_public_path__ + "static/media/welcome-church-logo.2a9e44bd.svg";